import { render, staticRenderFns } from "./place_panel.vue?vue&type=template&id=40fed4c2&scoped=true&"
import script from "./place_panel.vue?vue&type=script&lang=js&"
export * from "./place_panel.vue?vue&type=script&lang=js&"
import style0 from "./place_panel.vue?vue&type=style&index=0&id=40fed4c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fed4c2",
  null
  
)

export default component.exports